export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-xs font-semibold uppercase tracking-[0.14em] text-ink/60">{label}</span>
    <div className="mt-2">{children}</div>
    {hint && <span className="text-xs text-ink/45 mt-1 block">{hint}</span>}
  </label>
);

export const inputCls = "w-full h-12 px-4 bg-white border border-ink/20 focus:border-ink focus:outline-none focus:ring-2 focus:ring-[color:var(--c,#45ADE0)]/30 transition-colors";
export const areaCls = "w-full min-h-[130px] p-4 bg-white border border-ink/20 focus:border-ink focus:outline-none transition-colors";

export const ChoiceGroup = ({ options, value, onChange, multi = false, color = "#45ADE0", prefix }) => {
  const isOn = (v) => (multi ? value.includes(v) : value === v);
  const toggle = (v) => {
    if (!multi) return onChange(v);
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };
  return (
    <div className="grid sm:grid-cols-2 gap-3">
      {options.map(({ value: v, label, desc, c }) => (
        <button
          type="button"
          key={v}
          data-testid={`${prefix}-${v}`}
          onClick={() => toggle(v)}
          className={`text-left p-4 border-2 transition-colors bg-white ${isOn(v) ? "" : "border-ink/10 hover:border-ink/30"}`}
          style={isOn(v) ? { borderColor: c || color, background: `${c || color}12` } : {}}
        >
          <span className="flex items-center gap-2 font-semibold">
            <span className="h-3 w-3 border-2" style={{ borderColor: c || color, background: isOn(v) ? c || color : "transparent" }} />
            {label}
          </span>
          {desc && <span className="block text-xs text-ink/55 mt-1 pl-5">{desc}</span>}
        </button>
      ))}
    </div>
  );
};
